import apiClient from '../utils/apiClient';

export const purchaseOrderAPI = {
  // --- Suggested items (NVL thiếu stock) ---
  getSuggestedItems: async (branchId) =>
    apiClient.get({ url: `/purchase-orders/suggested-items/${branchId}` }),

  // --- Purchase Orders ---
  list: async (params = {}) =>
    apiClient.get({ url: '/purchase-orders', params }),

  getDetail: async (id) =>
    apiClient.get({ url: `/purchase-orders/${id}` }),

  getReceiptView: async (id) =>
    apiClient.get({ url: `/purchase-orders/${id}/receipt-view` }),

  getConfirmedForBranch: async (branchId) =>
    apiClient.get({ url: `/purchase-orders/confirmed/${branchId}` }),

  create: async (data) =>
    apiClient.post({ url: '/purchase-orders', data }),

  update: async (id, data) =>
    apiClient.patch({ url: `/purchase-orders/${id}`, data }),

  confirm: async (id) =>
    apiClient.post({ url: `/purchase-orders/${id}/confirm`, data: {} }),

  cancel: async (id) =>
    apiClient.post({ url: `/purchase-orders/${id}/cancel`, data: {} }),

  // --- Goods Receipts ---
  getGoodsReceipt: async (id) =>
    apiClient.get({ url: `/goods-receipts/${id}` }),

  getGoodsReceiptByPO: async (poId) =>
    apiClient.get({ url: `/goods-receipts/by-po/${poId}` }),

  getComparison: async (id) =>
    apiClient.get({ url: `/goods-receipts/${id}/comparison` }),

  reviewGoodsReceipt: async (id, action) =>
    apiClient.post({ url: `/goods-receipts/${id}/review`, data: { action } }),

  cancelGoodsReceipt: async (id) =>
    apiClient.post({ url: `/goods-receipts/${id}/cancel`, data: {} }),

  rollbackGoodsReceipt: async (id, reason) =>
    apiClient.post({ url: `/goods-receipts/${id}/rollback`, data: { reason } }),

  // #141201 — nhật ký thao tác phiếu kiểm kê. Nhận CẢ id phiếu kiểm LẪN id đơn đặt hàng: phiếu
  // bị "Huỷ"/"Đơn hàng chưa đến" bị xoá hẳn khỏi CSDL, lúc đó chỉ còn id đơn để tra lịch sử.
  getGoodsReceiptEvents: async (id) =>
    apiClient.get({ url: `/goods-receipts/${id}/events` }),

  getGoodsReceiptNoInteraction: async (id) =>
    apiClient.get({ url: `/goods-receipts/${id}/no-interaction` }),
};

export const supplierMaterialAPI = {
  list: async (params = {}) =>
    apiClient.get({ url: '/supplier-materials', params }),

  listBySupplier: async (supplierId, branchId) =>
    apiClient.get({ url: `/supplier-materials/by-supplier/${supplierId}`, params: { branch_id: branchId } }),

  create: async (data) =>
    apiClient.post({ url: '/supplier-materials', data }),

  update: async (id, data) =>
    apiClient.patch({ url: `/supplier-materials/${id}`, data }),

  bulkUpsert: async (data) =>
    apiClient.post({ url: '/supplier-materials/bulk', data }),

  remove: async (id) =>
    apiClient.delete({ url: `/supplier-materials/${id}` }),
};

// --- Gửi đơn đặt hàng cho NCC qua Zalo (#145947) ---
// MỖI CHI NHÁNH MỘT TIN RIÊNG: payload `branches` có bao nhiêu phần tử thì gửi bấy nhiêu tin.
export const supplierOrderZaloAPI = {
  preview: async (data) =>
    apiClient.post({ url: '/supplier-orders/zalo/preview', data }),

  send: async (data) =>
    apiClient.post({ url: '/supplier-orders/zalo/send', data }),

  history: async (params = {}) =>
    apiClient.get({ url: '/supplier-orders/zalo/history', params }),
};

// --- Mua NVL qua Shopee — BÁN TỰ ĐỘNG (#233654) ---
// Máy dò ra cần mua gì + mở thẳng đúng sản phẩm; NGƯỜI bấm mua và trả tiền.
// KHÔNG có API nào gọi sang Shopee: chỉ đọc link do người dùng tự dán.
export const shopeeShoppingAPI = {
  getList: async (branchId, params = {}) =>
    apiClient.get({ url: `/shopee-shopping/list/${branchId}`, params }),

  listPurchases: async (params = {}) =>
    apiClient.get({ url: '/shopee-shopping/purchases', params }),

  markPurchased: async (data) =>
    apiClient.post({ url: '/shopee-shopping/purchases', data }),

  unmarkPurchased: async (id) =>
    apiClient.delete({ url: `/shopee-shopping/purchases/${id}` }),

  checkLink: async (url) =>
    apiClient.get({ url: '/shopee-shopping/check-link', params: { url } }),
};

// --- "NCC đang cần đặt hàng" (#002620) ---
// Gom NVL dưới ngưỡng THEO NHÀ CUNG CẤP. Không đặt hàng hộ: mỗi kênh chỉ mở đúng luồng sẵn có
// (Zalo → màn gửi đơn Zalo, Shopee → màn "Cần mua qua Shopee", gọi điện → tel: + đánh dấu đã đặt).
export const supplierOrderNeedsAPI = {
  // branchId bỏ trống / 'all' = xem tất cả chi nhánh một lượt
  getNeeds: async (branchId) =>
    apiClient.get({ url: '/supplier-order-needs', params: branchId ? { branch_id: branchId } : {} }),

  // "Đã đặt" = tạo đơn đặt hàng CONFIRMED thật (PurchaseOrderStatus sẵn có), KHÔNG phải ô tick riêng
  markOrdered: async (data) =>
    apiClient.post({ url: '/supplier-order-needs/mark-ordered', data }),
};
